import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserCardResponseWrap} from "../../interface/userCardResponseWrap";
import {UserCardResponse} from "../../interface/userCardResponse";
import {UserCardService} from "../../service/user-card.service";
import {SubscriptionResponse} from "../../interface/subscriptionResponse";
import {TeamService} from "../../service/team.service";
import {QrCopyMessageComponent} from "../../qr-copy-message/qr-copy.component";
import {MockupDataModel} from "../../qr-copy-message/mockup-data.model";
import {MockupType} from "../../qr-copy-message/mockup-type.enum";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Team} from "../../interface/team";
import {SharedService} from "../../service/shered.service";
import {SnackBarUtil} from "../../qr-copy-message/snack-bar-util.service";
import {TranslateService} from "@ngx-translate/core";
import {tap} from "rxjs/operators";

@Component({
    selector: 'app-move-or-remove-dialog',
    templateUrl: './move-or-remove-dialog.component.html',
    styleUrl: './move-or-remove-dialog.component.scss'
})
export class MoveOrRemoveDialogComponent implements OnInit {
    wrappedIndividualCards: UserCardResponseWrap[] = [];
    isFavoriteMap: { [key: string]: boolean } = {};
    price: number = 0
    selectedCardIds: bigint[] = [];
    isSelectAllChecked = false;
    activeTeamSubscriptionPlan!: SubscriptionResponse;
    isDisableMoveOrRemove = false
    message: string = ''
    team!: Team
    maxAllowedCards: number = 0
    errorMessage: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<MoveOrRemoveDialogComponent>,
        private userCardService: UserCardService,
        private teamService: TeamService,
        private snackBar: MatSnackBar,
        private sharedService: SharedService,
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.loadIndividualsCard()
        this.getPrice()
        this.activeTeamSubscriptionPlan = this.data.activeTeamSubscriptionPlan
        this.teamService.getCurrentUserTeam().subscribe(team => {
            this.maxAllowedCards = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.cardCount - team.userCards.length;
            if (this.activeTeamSubscriptionPlan.subscriptionInfoResponse.cardCount <= team.membersCount) {
                this.isDisableMoveOrRemove = true
            }
        })
    }

    loadIndividualsCard() {
        if (Array.isArray(this.data.additionalCards)) {
            this.wrappedIndividualCards = this.data.additionalCards.map((card: UserCardResponse) => ({
                userCardResponse: card,
                isChecked: false
            }));
        }
    }

    getPrice() {
        this.data.additionalCards.forEach((card: {
            subscription: { subscriptionInfoResponse: { nextCardPrice: number } }
        }) => {
            this.price = card.subscription.subscriptionInfoResponse.nextCardPrice;
        });
    }

    closePopUp() {
        this.dialogRef.close()
    }

    onCardCheckboxChange(event: Event, wrappedCard: UserCardResponseWrap) {
        const checkbox = event.target as HTMLInputElement;

        if (checkbox.checked) {
            this.selectedCardIds.push(wrappedCard.userCardResponse.id);
        } else {
            this.selectedCardIds = this.selectedCardIds.filter(id => id !== wrappedCard.userCardResponse.id);
        }
        this.isSelectAllChecked = this.wrappedIndividualCards.every(card => card.isChecked);
        this.calculateLimitCount(this.selectedCardIds.length)
    }

  onSelectAll(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    this.wrappedIndividualCards.forEach(card => {
      card.isChecked = isChecked;
      if (isChecked) {
        if (!this.selectedCardIds.includes(card.userCardResponse.id)) {
          this.selectedCardIds.push(card.userCardResponse.id);
        }
      } else {
        this.selectedCardIds = [];
      }
    });
    this.calculateLimitCount(this.selectedCardIds.length)
  }

    removeCards() {
        if (this.selectedCardIds.length) {
            this.userCardService.deleteCardsByIdes(this.selectedCardIds).subscribe(_ => {
              this.translateService.get('cards_removed_success')
                .subscribe({
                  next: (res: string) => {
                    this.message = res;
                    this.afterAction(this.message);
                  }
                });
            })
        }
    }

  moveToSubscription() {
    if (!this.maxAllowedCards) {
      return
    }
    if (this.selectedCardIds.length) {
      this.userCardService.moveToSubscription(this.selectedCardIds, this.activeTeamSubscriptionPlan.id).subscribe(_ => {
        this.translateService.get('cards_moved_success').subscribe({
          next: (res: string) => {
            this.message = res;
            this.afterAction(this.message);
          }
        });
      })
    }
  }

    afterAction(successMessage: string) {
        this.closePopUp();
        this.sharedService.AClicked();
        this.message = successMessage;
        this.showSnackbar(this.message, SnackBarUtil.CLASSES.success);
    }

    calculateLimitCount(selectedItemsCount: number) {
      if (this.maxAllowedCards === 0) {
        this.errorMessage = this.translateService.instant('user_card.no_cards_allowed');
        this.isSelectAllChecked = false;
      } else if (selectedItemsCount > this.maxAllowedCards) {
            this.errorMessage = this.translateService.instant('user_card.cards_left_error', { count: this.maxAllowedCards });
            this.isSelectAllChecked = false;
        } else {
            this.errorMessage = '';
        }
    }

    private showSnackbar(message: string, panelClassNames: string[]): void {
        this.snackBar.openFromComponent(QrCopyMessageComponent, {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: panelClassNames,
            data: new MockupDataModel(message, MockupType.SUCCESS),
        });
    }

}
